// Admin-only writer for activity_scoring_config. Receives the list of
// "dirty" rows (the admin UI already filtered out unchanged rows) and
// PATCHes them through workspaceProject.activity.updateScoringConfig.
// Server enforces is_admin() gate (RLS policy `scoring_write`), so
// non-admins silently fail.
//
// Returns true on success, false on failure — the caller uses
// the flag to decide whether to flip the local state to "saved".
//
// migrated 2026-04-27 to SDK route workspaceProject.activity.updateScoringConfig

import { getSDK } from '../../../shared/functions/sdk.js'

export const updateActivityScoring = async function (dirty) {
  if (!Array.isArray(dirty) || !dirty.length) return true
  const me = this?.state?.root?.currentUserEmail || null
  const now = new Date().toISOString()
  const rows = dirty.map((r) => ({
    activity_type: r.activity_type,
    enabled: r._draftEnabled,
    score: r._draftScore,
    updated_at: now,
    updated_by: me,
  }))
  try {
    await getSDK().execute('workspaceProject.activity', 'updateScoringConfig', { rows })
    return true
  } catch (err) {
    console.error('[updateActivityScoring]', err?.message || err)
    return false
  }
}
